import { useEffect, useRef } from 'react';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { notification } from '@/app/core/notifications/notification';

import { notificationSuccess } from '../../../../core/toast';
import { useGetFormConnection } from '../../services/signalr.hooks';

export const HandlerLostConnection = ({
  setLoading
}: {
  setLoading: (value: { active: boolean; title: string }) => void;
}) => {
  const connection = useGetFormConnection();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const lostConnection = useRef(false);
  const isUnmounting = useRef(false);

  useEffect(() => {
    connection?.onreconnecting((error) => {
      lostConnection.current = true;
      setLoading({ active: true, title: t('formDefinition.label.reconecting') });
    });
  }, [connection, setLoading, t]);

  useEffect(() => {
    connection?.onreconnected((error) => {
      notificationSuccess(t('formDefinition.label.reconected'));
      lostConnection.current = false;
      setLoading({ active: false, title: t('formDefinition.label.reconected') });
    });
  }, [connection, setLoading, t]);

  useEffect(() => {
    isUnmounting.current = false;

    connection?.onclose((error) => {
      if (isUnmounting.current) {
        return;
      }

      if (lostConnection.current) {
        notification.error('Connection lost');
        navigate('/');
      }
    });

    return () => {
      isUnmounting.current = true;
    };
  }, [connection, navigate]);

  return <></>;
};
